module.exports = __webpack_public_path__ + "img/sale1.edd22224.png";